const TONLAR = {
  info:    'bg-brand-50 border-brand-200 text-brand-800',
  success: 'bg-emerald-50 border-emerald-200 text-emerald-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
  error:   'bg-rose-50 border-rose-200 text-rose-800',
};

export default function Alert({ ton = 'info', icon: Icon, children, className = '' }) {
  return (
    <div className={`flex items-start gap-2.5 border rounded-xl px-4 py-3 text-sm ${TONLAR[ton] || TONLAR.info} ${className}`}>
      {Icon && <Icon size={16} className="flex-shrink-0 mt-0.5" />}
      <div className="min-w-0">{children}</div>
    </div>
  );
}
